import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

type CheckboxOwnProps = {
  /**
   * The size of the component
   * @default medium
   */
  size?: 'medium' | 'small'
}

type CheckboxProps = CheckboxOwnProps &
  Omit<ComponentProps<'input'>, 'size' | 'type'>

/**
 * Checkboxes give users binary choices when presented with multiple options in a series.
 */
export const Checkbox = (props: CheckboxProps): JSX.Element => {
  const { className, size = 'medium', ...inputProps } = props

  return (
    <input
      {...inputProps}
      className={clsx(
        'checkbox',
        size === 'medium' && 'checkbox_medium',
        size === 'small' && 'checkbox_small',
        className,
      )}
      type="checkbox"
    />
  )
}
